<template>
  <div class="post_Detail">
    <div>
      <div
        class="weeklyBox boxLine"
        v-for="(weeklyReportDetailItem,i) in weeklyReportDailyDataArray"
        :key="weeklyReportDetailItem.id">
        <div>
          <table border="0" width="100%">
              <tr>
                <td style="vertical-align:top;width:90px;"> 
                     <div class="dayDateArea">
                        <div :class="i==5||i==6?'redTitle':''" style="text-align:center;">
                            <span>{{weeklyReportDetailItem.currentDay|currentDateFilter}}</span>
                        </div>
                        <div :class="i==5||i==6?'redTitle':''" style="text-align:center;margin-top:10px;">
                            <span>{{weeklyReportDetailItem.currentDay|currentDayFilter}}</span>
                        </div>
                     </div>

                     <div class="weeklyBoxDate" v-if="weeklyReportDetailItem.totalTime">
                      <span>总工时：</span>
                      <span>{{weeklyReportDetailItem.totalTime}}</span>
                    </div>
                </td>
                <td>
                  <div>
                     <el-form ref="ruleForm" :model="weeklyReportDetailItem" :rules="rules" @submit.native.prevent
                      :show-message="false">
                      <table border="0" cellspacing="0" cellpadding="2" class="weeklyReportTable">
                        <tbody>
                          <tr class="tableTitleRow">
                            <td width="20%" class="td_weeklyReportPost">项目</td>
                            <td width="20%" class="td_weeklyReportPost">任务类别</td>
                            <td class="td_weeklyReportPost">工作内容</td>
                            <td width="7%" class="td_weeklyReportPost">工时</td>
                            <td width="6%" class="td_weeklyReportPost">&nbsp;</td>
                          </tr>
                          <tr v-for="(projectItem,projectIndex) in weeklyReportDetailItem.weeklyReportItem_Project" 
                            :key="projectIndex" >
                            <td class="td_weeklyReportPost">
                                <el-form-item label=" " 
                                :prop="'weeklyReportItem_Project.' + projectIndex + '.projectId'" :rules="rules.projectId">
                                  <!-- <span>
                                    {{projectItem.projectName}}
                                    {{projectItem.projectSerialNumber!=""?" (" + projectItem.projectSerialNumber + ")":""}}
                                  </span> -->
                                  <el-input :value="projectItem.projectName" readonly>
                                    <!-- {{projectItem.projectName}}
                                    {{projectItem.projectSerialNumber!=""?" (" + projectItem.projectSerialNumber + ")":""}} -->
                                  </el-input>
                                  <div class="tableChoose_btn">
                                    <el-button
                                      type="text"
                                      size="medium"
                                      @click="showChooseProjectView(projectItem,projectIndex,i)">选</el-button>
                                    <el-button
                                      type="text"
                                      size="medium"
                                      @click="clearProject(projectItem)">清</el-button>
                                  </div>
                                </el-form-item>
                            </td>
                            <td class="td_weeklyReportPost">                
                                <el-form-item label=" " 
                                :prop="'weeklyReportItem_Project.' + projectIndex + '.projectTaskId'"
                                :rules="rules.projectTaskId">
                                  <!-- <span>{{projectItem.projectTaskName}}</span> -->
                                  <el-input v-model="projectItem.projectTaskName" readonly></el-input>
                                  <div class="tableChoose_btn" >
                                    <el-button
                                      type="text"
                                      size="medium"
                                      @click="showChooseProjectTaskView(projectItem,projectIndex,i)">选</el-button>
                                    <el-button
                                      type="text"
                                      size="medium"
                                      @click="clearProjectTask(projectItem)">清</el-button>
                                  </div>
                                </el-form-item>
                            
                            <td class="td_weeklyReportPost">
                              <el-input type="textarea" v-model="projectItem.content"></el-input>
                            </td>

                            <td class="td_weeklyReportPost">
                                <el-form-item label=" " 
                                  :prop="'weeklyReportItem_Project.' + projectIndex + '.spentTime'"
                              :rules="rules.spentTime">
                                  <el-input
                                    v-model="projectItem.spentTime"
                                    @change="changeSpentTime(projectItem)"></el-input>
                                </el-form-item>
                            </td>

                            <td class="td_weeklyReportPost">
                              <el-button
                                type="text"
                                class="removeBtn"
                                @click="removeWeeklyReportItem(weeklyReportDetailItem.weeklyReportItem_Project,projectIndex)">移除</el-button>
                            </td>
                          </tr>
                          <tr>
                            <td  class="td_weeklyReportPost">
                              <el-button plain size="mini"
                              @click="addProjectOnDetailView(weeklyReportDetailItem.weeklyReportItem_Project,weeklyReportDetailItem.currentDay)">
                              添加</el-button>
                              <!-- <el-button
                                  class="pulsBtn"
                                  type="text"
                                  @click="addProjectOnDetailView(weeklyReportDetailItem.weeklyReportItem_Project,weeklyReportDetailItem.currentDay)">
                                  <i class="el-icon-plus"></i>
                                </el-button> -->
                            </td>
                            <td class="td_weeklyReportPost"></td>
                            <td class="td_weeklyReportPost"></td>
                            <td class="td_weeklyReportPost"></td>
                            <td class="td_weeklyReportPost"></td>
                          </tr>
                        </tbody>
                        </table>
                      </el-form>
                      </div>
                       <div style="margin-top:20px;">
                          <el-form :model="weeklyReportDetailItem" :rules="rules" ref="ruleForm" @submit.native.prevent
                          :show-message="false">
                          <table border="0" cellspacing="0" cellpadding="2" class="weeklyReportTable">
                            <tbody>
                              <tr class="tableTitleRow">
                                <td width="30%" class="td_weeklyReportPost">日常工作</td>
                                <td class="td_weeklyReportPost">工作内容</td>
                                <td width="7%" class="td_weeklyReportPost">工时</td>
                                <td width="6%" class="td_weeklyReportPost">&nbsp;</td>
                              </tr>

                              <tr v-for="(taskItem,taskIndex) in weeklyReportDetailItem.weeklyReportItem_Task"
                                :key="taskIndex">
                                <td class="td_weeklyReportPost">
                                    <el-form-item label=" " 
                                    :prop="'weeklyReportItem_Task.' + taskIndex + '.taskId'" :rules="rules.taskId">
                                      <el-select v-model="taskItem.taskId">
                                      <!-- @change="changeTask(taskItem,taskIndex,i)" -->
                                        <el-option
                                          v-for="item in taskList"
                                          :key="item.id"
                                          :label="item.name"
                                          :value="item.id"></el-option>
                                      </el-select>
                                    </el-form-item>
                                </td>
                                <td class="td_weeklyReportPost">
                                  <el-input type="textarea" v-model="taskItem.content"></el-input>
                                </td>

                                <td class="td_weeklyReportPost">
                                    <el-form-item label=" "  :prop="'weeklyReportItem_Task.' + taskIndex + '.spentTime'" :rules="rules.spentTime">
                                      <el-input v-model="taskItem.spentTime" @change="changeSpentTime(taskItem)"></el-input>
                                    </el-form-item>
                                </td>

                                <td class="td_weeklyReportPost">
                                  <el-button
                                    type="text"
                                    class="removeBtn"
                                    @click="removeWeeklyReportItem(weeklyReportDetailItem.weeklyReportItem_Task,taskIndex)">移除</el-button>
                                </td>
                              </tr>
                              <tr>
                                <td class="td_weeklyReportPost">
                                  <el-button plain size="mini"
                                    @click="addTaskOnDetailView(weeklyReportDetailItem.weeklyReportItem_Task,weeklyReportDetailItem.currentDay)">
                                    添加</el-button>
                                    <!-- <el-button
                                      class="pulsBtn"
                                      type="text"
                                      @click="addTaskOnDetailView(weeklyReportDetailItem.weeklyReportItem_Task,weeklyReportDetailItem.currentDay)">
                                      <i class="el-icon-plus"></i>
                                    </el-button> -->
                                </td>
                                <td class="td_weeklyReportPost">&nbsp;</td>
                                <td class="td_weeklyReportPost">&nbsp;</td>
                                <td class="td_weeklyReportPost">&nbsp;</td>
                              </tr>
                            </tbody>
                          </table>
                          </el-form>          
                        </div>
                </td>
              </tr>
          </table>
         
         


        </div>
       
      </div>

      <chooseProject
        ref="chooseProject"
        :propsData="projectChooseViewProps"
        @chooseProjectCallback="chooseProjectCallback"></chooseProject>

       <chooseProjectTask
        ref="chooseProjectTask"
        :propsData="projectTaskChooseViewProps"
        @chooseProjectTaskCallback="chooseProjectTaskCallback"></chooseProjectTask>
    </div>
  </div>
</template>

<script>
import { dateFtt, isArrayRepeat } from "@/utils/auth.js";
import chooseProject from "../common/chooseProject";
import chooseProjectTask from "../common/chooseProjectTask";

export default {
  name: "post_Detail",
  components: { chooseProject,chooseProjectTask },
  props: ["taskList", "currentWeekInfo", "getWeeklyReportByUserArgs"],
  data() {
    return {
      projectChooseViewProps: {
        visible: false
      },
      projectTaskChooseViewProps:{
        visible: false,
        projectId:""
      },
      rules: {
        // spentTime: [
        //   { required: true, message: "请输入工时", trigger: "change" }
        // ],
        taskId: [
          { required: true, message: "请选择任务", trigger: "change" }
        ],
        projectId: [
          { required: true, message: "请选择项目", trigger: "change" }
        ],
         projectTaskId: [
          { required: true, message: "请选择项目的任务", trigger: "change" }
        ]
      },
     
      //因为在周报视图要按天输出，这里是按天组织过的数据
      weeklyReportDailyDataArray: [
        {
          weeklyReportItem_Task: [
            {
              // id:null,
              // weeklyReportId:null,
              taskId: "",
              taskName:"",
              content: "",
              date: "",
              spentTime: "",
              numericalOrder: 1,
            }
          ],
          weeklyReportItem_Project: [
            {
              // id:null,
              // weeklyReportId:null,
              projectId: "",
              projectName:"",
              projectTaskId:"",
              projectTaskName:"",
              projectStatusId:"",
              content: "",
              date: "",
              spentTime: "",
              numericalOrder: 1,
            //  taskList:[]
            }
          ],
          currentDay: ""
        }
      ],
      editingProjectItem: {
      },  //新增项目条目时产生的临时数据
      weeklyReportDetailListIndex: 0, //记录当前选择项目在哪一天
      weeklyReportItemIndex: 0 //记录当前选择项目在所在日期的哪一行
    };
  },
  filters: {
    currentDateFilter: function(value) {
      // return dateFtt("yyyy年MM月dd日 EEE ", value);
       return dateFtt("MM月dd日", value);
    },
    currentDayFilter: function(value) {
      // return dateFtt("yyyy年MM月dd日 EEE ", value);
       return dateFtt("EEE", value);
    }
  },
  mounted() {
      
  },
  methods: {
    //data是服务端返回的原始周报数据
    loadWeeklyReportData(data) 
    {
      this.weeklyReportDailyDataArray = [];
      
      if (data == null) 
      {
        this.createWeeklyReportDailyDataArray([]);
      } 
      else 
      {
        let viewData = this.convertServerDataToViewData(data);
        this.createWeeklyReportDailyDataArray(this.computeDailyTotalSpentTime(viewData));
      }      
    },

    //周报视图按照日期格式从星期一到星期天展示
    //对视图对象进一步加工，确保每一天都有完整的对象
    createWeeklyReportDailyDataArray(viewData) 
    {
      let startTime = new Date(this.currentWeekInfo.monday);
      this.weeklyReportDailyDataArray = [];

      if (viewData.length == 0) 
      {
        for (var i = 0; i < 7; i++) 
        {
          let currentTime = dateFtt("yyyy/MM/dd hh:mm:ss",startTime.getTime() + 24 * 60 * 60 * 1000 * i);
          this.weeklyReportDailyDataArray.push(
          {
            weeklyReportItem_Task: [],
            weeklyReportItem_Project: [],
            currentDay: currentTime
          });
        }
      } 
      else 
      {
        for (var j = 0; j < 7; j++) 
        {
          let currentTime = dateFtt("yyyy/MM/dd hh:mm:ss",startTime.getTime() + 24 * 60 * 60 * 1000 * j);
          let exist = false;

          viewData.forEach(item => 
          {
            if (item.currentDay == currentTime) 
            {
              exist = true;
              if (!item.weeklyReportItem_Task) 
              {
                item.weeklyReportItem_Task = [];
              }
              if (!item.weeklyReportItem_Project) 
              {
                item.weeklyReportItem_Project = [];
              }
              this.weeklyReportDailyDataArray.push(item);
            }
          });
          if (exist == false) 
          {
            this.weeklyReportDailyDataArray.push(
            {
              weeklyReportItem_Task: [],
              weeklyReportItem_Project: [],
              currentDay: currentTime
            });
          }
        }
      }

    },
    
    //服务端数据转化为周报视图数据
    //这里得到的数据，有可能并不包含 每一天 的对象
    //只单纯的把既有数据转成视图格式
    convertServerDataToViewData(resData) {
      
      let viewData = [];
      let weeklyReportItem_Task = resData.weeklyReportItem_Task || [];
      let weeklyReportItem_Project = resData.weeklyReportItem_Project || [];

      if (weeklyReportItem_Task.length != 0) 
      {
        weeklyReportItem_Task.forEach(taskItem => 
        {
          if (viewData.length == 0) 
          {
            viewData.push(
              {
                weeklyReportItem_Task: [taskItem],
                currentDay: taskItem.date
              }
              );
          } 
          else 
          {
            let isItemExist = false;
            viewData.forEach(weeklyReportItem => 
            {
              if (weeklyReportItem.currentDay === taskItem.date) 
              {
                isItemExist = true;
                weeklyReportItem.weeklyReportItem_Task.push(taskItem);
              }
            });
            if (!isItemExist) 
            {
              let taskObj = 
              {
                weeklyReportItem_Task: [taskItem],
                currentDay: taskItem.date
              };
              // taskObj.weeklyReportItem_Task.push(taskItem);
              viewData.push(taskObj);
            }
          }
        });
      }


      if (weeklyReportItem_Project.length != 0) 
      {
        weeklyReportItem_Project.forEach(projectItem => 
        {
            if (viewData.length == 0) 
            {
              viewData.push(
                {
                  weeklyReportItem_Project: [projectItem],currentDay: projectItem.date
                });
            } 
            else 
            {
              let exist = false;
              viewData.forEach(weeklyReportItem => 
              {
                if (weeklyReportItem.currentDay === projectItem.date) 
                {
                  exist = true;
                  if (weeklyReportItem.weeklyReportItem_Project) 
                  {
                    weeklyReportItem.weeklyReportItem_Project.push(projectItem);
                  } else 
                  {
                    weeklyReportItem.weeklyReportItem_Project = [];
                    weeklyReportItem.weeklyReportItem_Project.push(projectItem);
                  }
                }
              });
              if (!exist) 
              {
                let dataObj = 
                {
                  weeklyReportItem_Project: [projectItem],
                  currentDay: projectItem.date
                };
                // dataObj.weeklyReportItem_Project.push(item);
                viewData.push(dataObj);
              }
            }
          }
        );
      }

      return viewData;
    },
   
    //周报视图新增项目
    addProjectOnDetailView(currentList, currentDay) {
      let item = {
        content: "",
        date: currentDay,
        spentTime: "",
        numericalOrder: 1,
        projectId: "",
        projectTaskId:"",
        projectStatusId:"",
        projectSerialNumber: "",
        projectName: "",
        projectTaskName: ""
       // taskList:[]
      };
      currentList.push(item);
    },
    //周报视图新增日常工作
    addTaskOnDetailView(currentList, currentDay) {
      let item = {
        taskId: "",
        content: "",
        date: currentDay,
        spentTime: "",
        numericalOrder: 1
      };
      currentList.push(item);
    },
    //周报视图移除方法
    removeWeeklyReportItem(currentList, index) {
      currentList.splice(index, 1);
      this.weeklyReportDailyDataArray = this.computeDailyTotalSpentTime(this.weeklyReportDailyDataArray);
    },
    //工时变化
    changeSpentTime(item) {
      if (isNaN(item.spentTime)) {
        item.spentTime = "";
      }
      this.weeklyReportDailyDataArray = this.computeDailyTotalSpentTime(this.weeklyReportDailyDataArray);
      this.weeklyReportDailyDataArray.splice(1, 0);
    },
    //计算每天的总工时
    computeDailyTotalSpentTime(dataArray) {
      if (dataArray.length == 0) 
        return [];

      dataArray.forEach(item => {
        let s = 0;
        if (item.weeklyReportItem_Task) {
          item.weeklyReportItem_Task.forEach(taskItem => {
            s += Number(taskItem.spentTime);
          });
        }
        if (item.weeklyReportItem_Project) {
          item.weeklyReportItem_Project.forEach(projectItem => {
            s += Number(projectItem.spentTime);
          });
        }
        item.totalTime = s;
      });

      return dataArray;
    },

    //选择项目弹窗
    showChooseProjectView(projectItemInViewData, index, i) {
      this.editingProjectItem = projectItemInViewData;
      this.weeklyReportItemIndex = index;
      this.weeklyReportDetailListIndex = i;

      this.$refs.chooseProject.show();
    },
    chooseProjectCallback(args) {

      if(this.editingProjectItem.projectId == args.id)
        return;

     // debugger;

      this.editingProjectItem.projectId = args.id;
      this.editingProjectItem.projectStatusId = args.statusId;
      this.editingProjectItem.projectSerialNumber = args.serialNumber;
      this.editingProjectItem.projectName = args.name;

      this.clearProjectTask(this.editingProjectItem);

    },

    clearProject(projectItem) {
      projectItem.projectSerialNumber = "";
      projectItem.projectId = "";
      projectItem.projectStatusId = "",
      projectItem.projectName = "";
      projectItem.projectTaskId = "";
      projectItem.projectTaskName = "";
    },

    //选择任务类别
    showChooseProjectTaskView(projectItemInViewData, index, i){
        if(!projectItemInViewData.projectId){
          this.$alert("请先选择一个项目。", "提示");
          return;
        }

        this.editingProjectItem = projectItemInViewData;
        this.weeklyReportItemIndex = index;
        this.weeklyReportDetailListIndex = i;
        this.projectTaskChooseViewProps.visible = true;
        this.projectTaskChooseViewProps.projectId = projectItemInViewData.projectId;
        this.$refs.chooseProjectTask.getDataList();
    },
    chooseProjectTaskCallback(args) {
      this.projectTaskChooseViewProps.visible = false;

      this.editingProjectItem.projectTaskId = args.id;
      this.editingProjectItem.projectTaskName = args.name;
    },
    clearProjectTask(projectItem){
      projectItem.projectTaskId = "";
      projectItem.projectTaskName = "";
    },

    //判断选择的项目是不是已经存在了
    // changeProject() {
    //   let exist = false;
    //   let editingProjectItem = this.editingProjectItem;

    //   this.weeklyReportDailyDataArray[this.weeklyReportDetailListIndex]
    //     .weeklyReportItem_Project.map((val, j) => 
    //     {
    //       if (j == this.weeklyReportItemIndex) 
    //         return;

    //       if (val.projectId == editingProjectItem.projectId) 
    //       {
    //         this.$alert("当天已有该项目编号，请勿重复添加", "提示");
    //         editingProjectItem.projectId = "";
    //         editingProjectItem.projectName = "";
    //         editingProjectItem.projectSerialNumber = "";
    //       }
    //     });
    // },

    //判断日常工作有没有重复
    // changeTask(item, index, i) {
    //   let exist = false;
    //   this.weeklyReportDailyDataArray[i].weeklyReportItem_Task.map((val, j) => {
    //     if (j == index) 
    //       return;

    //     if (val.taskId == item.taskId) {
    //       this.$alert("当天已有该日常工作，请勿重复添加", "提示");
    //       item.taskId = "";
    //       exist = true;
    //     }
    //   });
    // },
   

    // 周报视图格式转化为提交格式
    convertViewDataToServerData() {

      let serverData = {};

      serverData.year = this.getWeeklyReportByUserArgs.year;
      serverData.month = this.getWeeklyReportByUserArgs.month;
      serverData.weekOfYear = this.getWeeklyReportByUserArgs.weekOfYear;
      
      serverData.weeklyReportItem_Task = [];
      serverData.weeklyReportItem_Project = [];

      this.weeklyReportDailyDataArray.forEach(item => {

        if(item.weeklyReportItem_Task!=undefined && item.weeklyReportItem_Task!= null)
        {
          item.weeklyReportItem_Task.forEach(taskVal => 
          {
            taskVal.year = serverData.year;
            taskVal.month = serverData.month;
            serverData.weeklyReportItem_Task.push(taskVal);
          });
        }

        if(item.weeklyReportItem_Project!=undefined && item.weeklyReportItem_Project!= null)
        {
          item.weeklyReportItem_Project.forEach(projectVal => 
          {
              projectVal.year = serverData.year;
              projectVal.month = serverData.month;
              serverData.weeklyReportItem_Project.push(projectVal);
          });
        }

      });
      
      return serverData;
    },

    //验证输入
    validate()
    {
        let validateResult = true;
        this.$refs["ruleForm"].forEach(item => {
          item.validate(valid => 
          {
            if (!valid) 
            {
              validateResult = false;
            }
          });
        });

        return validateResult;
    },

    

   

  }
};
</script>

<style  rel="stylesheet/scss" lang="scss">
.post_Detail {
  font-size: 14px;

  .tableTitleRow{
    // font-weight:bold;
    // color:rgb(88, 88, 88);
  }

  .dayDateArea
  {
    width: 80px;
    padding: 10px;
    border: solid 1px rgb(197, 216, 238);
    background-color: rgb(247, 247, 232);
    font-size: 12px;
  }
  .weeklyBox {
    margin-top: 0px;
    margin-bottom: 10px;
    padding: 15px;
    padding-right: 0;
  }
  .weeklyBoxDate {
    font-size: 12px;
    margin-top: 20px;
    margin-left:5px;
  }
  .weeklyReportTable {
    width: 100%;
    min-height: 100px;
    
    .td_weeklyReportPost {
      padding-left: 10px;
      padding-right: 10px;
      vertical-align: top;
    }
    .el-input__inner,
    .el-input__icon,
    .el-form-item__content {
      height: 30px;
      line-height: 30px;
    }
  
    .el-input__inner,
    .el-textarea__inner {
      // border: none !important;
      border-top:none !important;
      border-left:none !important;
      border-right:none !important;
      border-bottom: 1px solid #eeeeee;
      border-radius: 0 !important;
      padding: 0;
    }

    .el-form-item.is-error 
    .el-input__inner, 
    .el-form-item.is-error 
    .el-input__inner:focus, 
    .el-form-item.is-error 
    .el-textarea__inner, 
    .el-form-item.is-error 
    .el-textarea__inner:focus
    {
      border-bottom: 1px solid red;
    }
    // .el-textarea__inner {
    //   /* height: 60px; */
    //   padding-top: 5px;
    //   color: #606266;
    //   font-size: inherit;
    // }
    // .el-input.el-input--suffix,
    // .el-input,
    // .el-textarea {
    //   border-bottom: 1px solid #bbbbbb;
    // }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/weeklyReport/post_Detail.vue